import { useSelector } from 'react-redux';
import { getBuilder, getSellers } from '../../selectors/developerV2';
import * as React from 'react';

/* Логика телефонов на карточке застройщика:
 * Если есть застройщик с признаком showPhone: true, то отображается контакт застройщика
 * Иначе подставляются контакты представителей
 */
export const useContacts = () => {
  const rawBuilder = useSelector(getBuilder);
  const rawSellers = useSelector(getSellers);

  const builders = React.useMemo(() => {
    return rawBuilder?.showPhone ? [rawBuilder] : [];
  }, [rawBuilder]);
  const sellers = React.useMemo(() => (builders.length ? [] : rawSellers), [builders, rawSellers]);

  return {
    builders,
    sellers,
  };
};
